import { ActionIcon, Indicator, Text, Tooltip } from "@mantine/core"
import { IconCalendar } from "@tabler/icons-react"

import {
  emptyEvents,
  getEventsFromCategory,
} from "@costory/types/endpoints/events"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { useEventsQuery } from "@costory/front/queries/explore"

interface EventsButtonProps {
  onOpen: () => void
  eventsQuery: ReturnType<typeof useEventsQuery>
}

export const EventsButton = ({ onOpen, eventsQuery }: EventsButtonProps) => (
  <QueryWrapper defaultData={emptyEvents} query={eventsQuery} allowEmptyArray>
    {({ data }) => {
      const totalEvents = getEventsFromCategory(data, undefined, undefined)
        .map((el) => el.events)
        .flat().length

      return (
        <Tooltip label="Display Events">
          <Indicator
            inline
            size={25}
            offset={5}
            label={<Text fw={300}>{totalEvents > 9 ? "9+" : totalEvents}</Text>}
            processing={eventsQuery.isLoading}
          >
            <ActionIcon
              onClick={onOpen}
              size="xl"
              data-intercom-target="events-button"
            >
              <IconCalendar
                style={{ width: "70%", height: "70%" }}
                stroke={1.5}
              />
            </ActionIcon>
          </Indicator>
        </Tooltip>
      )
    }}
  </QueryWrapper>
)
